import { render, staticRenderFns } from "./CoffeeList.vue?vue&type=template&id=63c86aca&scoped=true"
import script from "./CoffeeList.vue?vue&type=script&lang=js"
export * from "./CoffeeList.vue?vue&type=script&lang=js"
import style0 from "./CoffeeList.vue?vue&type=style&index=0&id=63c86aca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c86aca",
  null
  
)

export default component.exports